import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";

const SearchableDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  label,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  console.log("Current value:", value);
  console.log("Available options:", options);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (option) => {
    console.log("Selected option:", option);
    onChange(option.value);
    setSelectedOption(option);
    setIsOpen(false);
    setSearchTerm("");
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const option = options.find(
      (option) => String(option.value) === String(value)
    );
    console.log("Matching option found:", option);
    setSelectedOption(option || null);
  }, [value, options]);

  console.log("Current selectedOption:", selectedOption);

  return (
    <div className={styles.dropdownContainer} ref={dropdownRef}>
      <label className={styles.label}>{label}</label>
      <div
        className={styles.dropdownTrigger}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption ? selectedOption.label : placeholder}
      </div>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <ul className={styles.optionsList}>
            {filteredOptions.map((option) => (
              <li
                key={option.value}
                className={styles.option}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
